import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource/authentication-context-datasource.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'idp-error-view',
  imports: [DatePipe],
  templateUrl: './idp-error-view.component.html',
  styleUrls: ['./idp-error-view.component.scss']
})
export class IdPErrorViewComponent {
  private activatedRoute = inject(ActivatedRoute);
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);

  public status = 0;

  constructor() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.authenticationContextDatasource.setContextData(params);

      if (params.status && params.status !== '') {
        this.status = Number(params.status);
      }
    });
  }

  public getDisplaySessionId(): string {
    return this.authenticationContextDatasource.getSessionId();
  }

  public getDateTime() {
    return this.authenticationContextDatasource.getDateTime();
  }
}
